/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Move_ArrowInputs */

const vi_pdc_move_arrow = /** @type {(inputs: Pdc_Move_ArrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`→`)
};

/**

* @param {Pdc_Move_ArrowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_move_arrow = /** @type {((inputs?: Pdc_Move_ArrowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Move_ArrowInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_move_arrow(inputs)
});